import React, { useState } from "react";
import AdminDataTable from "../components/AdminDataTable";
import Button from "../../../components/ui/Button";
import { Eye, CheckCircle, XCircle, AlertTriangle } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import { MoreVertical } from "lucide-react";

const ModerationQueuePage = () => {
  const [reports, setReports] = useState([
    {
      id: "report_1",
      type: "Post",
      content: "Inappropriate image posted",
      reportedBy: "Abebe T.",
      reason: "Inappropriate Content",
      status: "Pending",
      createdAt: "2h ago"
    },
    {
      id: "report_2",
      type: "Comment",
      content: "Spam link in comment section",
      reportedBy: "Mekdes A.",
      reason: "Spam",
      status: "Pending",
      createdAt: "5h ago"
    },
    {
      id: "report_3",
      type: "Profile",
      content: "Impersonating another creator",
      reportedBy: "Dawit B.",
      reason: "Copyright",
      status: "Reviewed",
      createdAt: "1d ago"
    }
  ]);

  const handleAction = (id, action) => {
    setReports(reports.map(r => 
      r.id === id ? { ...r, status: action === 'approve' ? 'Actioned' : 'Dismissed' } : r
    ));
  };

  const columns = [
    {
      header: "Type",
      key: "type",
      render: (row) => (
        <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded">
          {row.type}
        </span>
      )
    },
    {
      header: "Content",
      key: "content",
      render: (row) => (
        <span className="text-sm text-slate-700">{row.content}</span>
      )
    },
    {
      header: "Reported By",
      key: "reportedBy",
      render: (row) => row.reportedBy
    },
    {
      header: "Reason",
      key: "reason",
      render: (row) => row.reason
    },
    {
      header: "Status",
      key: "status",
      render: (row) => (
        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
          row.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' :
          row.status === 'Actioned' ? 'bg-green-100 text-green-700' :
          'bg-slate-100 text-slate-700'
        }`}>
          {row.status}
        </span>
      )
    },
    {
      header: "Age",
      key: "createdAt",
      render: (row) => row.createdAt
    },
    {
      header: "",
      key: "actions",
      render: (row) => (
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button
            as={Button}
            variant="ghost"
            size="sm"
            className="w-8 h-8 p-0"
          >
            <MoreVertical size={16} />
          </Menu.Button>
          <Transition
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-40 origin-top-right rounded-md bg-white shadow-lg z-10">
              <div className="px-1 py-1">
                <Menu.Item>
                  <button
                    onClick={() => handleAction(row.id, 'view')}
                    className="group flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900 hover:bg-primary hover:text-white"
                  >
                    <Eye className="mr-2 h-4 w-4" /> View Details
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => handleAction(row.id, 'approve')}
                    className="group flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900 hover:bg-green-500 hover:text-white"
                  >
                    <CheckCircle className="mr-2 h-4 w-4" /> Take Action
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => handleAction(row.id, 'dismiss')}
                    className="group flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900 hover:bg-red-500 hover:text-white"
                  >
                    <XCircle className="mr-2 h-4 w-4" /> Dismiss
                  </button>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      )
    }
  ];

  const pendingCount = reports.filter(r => r.status === 'Pending').length;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">Moderation Queue</h1>
          <p className="text-slate-500 mt-1">
            Review and action reported content. {pendingCount} pending review.
          </p>
        </div>
        {pendingCount > 0 && (
          <div className="flex items-center space-x-2 px-4 py-2 bg-yellow-50 border border-yellow-200 rounded-lg">
            <AlertTriangle className="text-yellow-600" size={20} />
            <span className="text-sm font-semibold text-yellow-800">
              {pendingCount} reports awaiting review
            </span>
          </div>
        )}
      </div>

      <AdminDataTable columns={columns} data={reports} />
    </div>
  );
};

export default ModerationQueuePage;
